import { Tabs, Tab } from "@mui/material";
import { BRAND_COLOR } from "./constants";

interface LeadsManagementTabsProps {
  view: "leads" | "analytics";
  onChangeView: (view: "leads" | "analytics") => void;
}

export default function LeadsManagementTabs({
  view,
  onChangeView,
}: LeadsManagementTabsProps) {
  return (
    <Tabs
      value={view}
      onChange={(_, value) => onChangeView(value)}
      sx={{
        mt: 2.5,
        borderBottom: "1px solid #e6e6e6",
        minHeight: 0,
        "& .MuiTab-root": {
          minHeight: 0,
          fontSize: 14,
          fontWeight: 500,
          letterSpacing: "0.6px",
          color: "#6b6b6b",
        },
        "& .Mui-selected": { color: `${BRAND_COLOR} !important` },
        "& .MuiTabs-indicator": { backgroundColor: BRAND_COLOR, height: 3 },
      }}
    >
      <Tab value="leads" label="LEADS" />
      <Tab value="analytics" label="ANALYTICS" />
    </Tabs>
  );
}
